<template>
  <bimEditorJS
    :value="value"
    @input="v => $emit('input', v)"
    formKey="value"
    :formModel="_self"
    :imgUploadURL="imgUploadURL"
    :customComponents="customComponents"
  />
</template>

<script>
import validationMixin from '../validation.mixin'
import bimEditorJS from '@/components/form/bimEditorJS/bimEditorJS'
export default {
  name: 'FieldEditorJS',
  mixins: [validationMixin],
  components: {
    bimEditorJS,
  },
  props: {
    value: {
      type: [Object, String],
    },
    imgUploadURL: String,
    customComponents: Object,
  },
}
</script>

<style scoped lang="scss">

</style>
